import type {
  TGuaranteesManagerStepKey,
  TGuaranteesManagerStepNavigationAccess,
} from './types.ts';

export const guaranteesManagerStepNavigationConfig: ReadonlyArray<{
  key: TGuaranteesManagerStepKey;
  title: string;
  requiresAccess?: keyof TGuaranteesManagerStepNavigationAccess;
}> = [
  {
    key: 'step1',
    title: 'Дані заявки',
  },
  {
    key: 'step2',
    title: 'PM менеджер',
  },
  {
    key: 'udbtf',
    requiresAccess: 'udbtf',
    title: 'УДБТФ',
  },
  {
    key: 'amApprovalLetter',
    requiresAccess: 'am',
    title: 'Лист-погодження AM',
  },
];
